export const dataGroupingDefault = {
  value: 'c',
  minutes: 0,
  translation: 'downloadDataForm.originalData'
}

export const dataGroupingMultipleDefault = '15min'

export const dataGroupingValues = [
  {
    value: '15min',
    minutes: 15,
    translation: 'downloadDataForm.grouping15'
  },
  {
    value: '30min',
    minutes: 30,
    translation: 'downloadDataForm.grouping30'
  },
  {
    value: '1H',
    minutes: 60,
    translation: 'downloadDataForm.grouping1'
  }
]
